import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counselors-menu',
  templateUrl: './counselors-menu.component.html',
  styleUrls: ['./counselors-menu.component.css']
})
export class CounselorsMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
